/**
 * Page walkthrough videos, keyed by route name.
 *
 * The navbar video button renders ONLY for routes listed here — a page with no
 * entry shows no icon at all. To add a guide, drop the Google Drive share link
 * in using the `/preview` form (the `/view` form will not embed in an iframe).
 */
export interface VideoGuide {
  /** Dialog heading, e.g. "Results Guide". */
  title: string;
  /** Google Drive (or other) embeddable URL — must end in /preview for Drive. */
  videoSrc: string;
}

export const videoGuides: Record<string, VideoGuide> = {
  'admin-student': {
    title: 'Student Guide',
    videoSrc: 'https://drive.google.com/file/d/1Ig0Yj_cx6wzd4TOPW9LcvZ54qZaNietB/preview',
  },
  'admin-teacher': {
    title: 'Staff Guide',
    videoSrc: 'https://drive.google.com/file/d/15cwJjc32h9wymbSSnyvKHuwOxR1b82Ng/preview',
  },
  'admin-invited-staff': {
    title: 'Staff Guide',
    videoSrc: 'https://drive.google.com/file/d/1DEYE5B3Vrc7nKyxABEiiOnr1144y3X7n/preview',
  },
  'admin-grade-system': {
    title: 'Grade System Guide',
    videoSrc: 'https://drive.google.com/file/d/15cwJjc32h9wymbSSnyvKHuwOxR1b82Ng/preview',
  },
  'admin-results': {
    title: 'Results Guide',
    videoSrc: 'https://drive.google.com/file/d/1v00WuPSvTjPqQHCbPKmZbEaMBEgSZISN/preview',
  },
  'admin-settings': {
    title: 'Settings Guide',
    videoSrc: 'https://drive.google.com/file/d/1-qyvfLH6LzYfne4asTuj0I_P02F7x2ht/preview',
  },
  'admin-forms': {
    title: 'Forms Guide',
    videoSrc: 'https://drive.google.com/file/d/1c93eYOzISIVUl3hapyNTTh76iWa0wfnb/preview',
  },
  'admin-my-courses': {
    title: 'My Courses Guide',
    videoSrc: 'https://drive.google.com/file/d/1kFv5UPOuYa--yRkomlBITlCSALJFPu6S/preview',
  },
  'student-courses': {
    title: 'Course Registration Guide',
    videoSrc: 'https://drive.google.com/file/d/1WT4fTHGVAmOsAmy5Sh-6S_ecHSev6V89/preview',
  },
  'student-course-reg': {
    title: 'Course Registration Guide',
    videoSrc: 'https://drive.google.com/file/d/1WT4fTHGVAmOsAmy5Sh-6S_ecHSev6V89/preview',
  },
};

export function getVideoGuide(routeName?: string | symbol | null): VideoGuide | null {
  if (typeof routeName !== 'string') return null;
  return videoGuides[routeName] ?? null;
}
